import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { EngagementType } from '@interfaces';
import { CommonEngagementGridPart } from '../../../../../ui/widget';
import { VolunteeringEngagementsService } from '../../volunteering-engagements.service';

@Component({
	selector: 'volunteering-open-engagements-view-part',
	standalone: true,
	imports: [CommonEngagementGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './open-engagements.part.html',
})
export class OpenEngagementsViewPart implements OnInit {
	public readonly pageService = inject(VolunteeringEngagementsService);
	public engagements = computed(() => (this.pageService.engagements() || []).filter(t => !t.closedUTC));

	ngOnInit() {
		this.pageService.engagementType.set(EngagementType.open);
	}

}